var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      attrs: { name: "update-user-permission", autocomplete: "off" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.updateUser.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "fieldset",
        { attrs: { disabled: _vm.loadingEdit || !_vm.editing } },
        [
          _c("div", { staticClass: "emd-panel__section" }, [
            _c("div", { staticClass: "emd-panel__block" }, [
              _c(
                "div",
                { staticClass: "el-chunk" },
                [
                  _c(
                    "emd-text",
                    { attrs: { tag: "h2", size: "medium", type: "caption" } },
                    [_vm._v(_vm._s(_vm.$t("users.permission")) + " ")]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "emd-panel__block" }, [
              _c(
                "div",
                { staticClass: "el-chunk" },
                [
                  _c("role-form-group", {
                    attrs: { userRole: _vm.role },
                    on: {
                      "update:model-value": (newValue) => (_vm.role = newValue),
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm.editing
            ? [
                _c("hr", { staticClass: "emd-divider eu-my_4" }),
                _c("password-confirmation", {
                  attrs: { label: "invite.create.password-label" },
                  model: {
                    value: _vm.password,
                    callback: function ($$v) {
                      _vm.password = $$v
                    },
                    expression: "password",
                  },
                }),
                _c(
                  "div",
                  { staticClass: "emd-container__footer eu-no-padding" },
                  [
                    _c(
                      "emd-button",
                      {
                        attrs: {
                          color: "primary",
                          type: "text",
                          "type-html": "button",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("cancelEditing")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("general.cancel")))]
                    ),
                    _c(
                      "emd-button",
                      {
                        attrs: {
                          disabled: _vm.shouldDisableSubmit,
                          color: "primary",
                          "type-html": "submit",
                        },
                      },
                      [
                        _vm.loadingEdit
                          ? _c("emd-loader")
                          : _c("span", [
                              _vm._v(_vm._s(_vm.$t("general.confirmation"))),
                            ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }